export class UpdateWorkspaceLoggingSettingsInputGcp {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "cloudLoggingEnabled",
            "baseName": "cloudLoggingEnabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "cloudLoggingLogId",
            "baseName": "cloudLoggingLogId",
            "type": "string",
            "format": ""
        },
        {
            "name": "gcsEnabled",
            "baseName": "gcsEnabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "gcsUri",
            "baseName": "gcsUri",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateWorkspaceLoggingSettingsInputGcp.attributeTypeMap;
    }
    constructor() {
    }
}
